import React, { Component } from 'react';
import axios from 'axios';
import { Box, Typography, Paper, Grid, CircularProgress, Alert } from '@mui/material';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import axiosInstance from "./axiosConfig";
import usersIcon from './images/DASH-ICON-1.png';
import usersHoverIcon from './images/DASH-ICON-1-HOVER.png';
import requestsIcon from './images/DASH-ICON-2.png';
import requestsHoverIcon from './images/DASH-ICON-2-HOVER.png';
import inspectionsIcon from './images/DASH-ICON-3.png';
import inspectionsHoverIcon from './images/DASH-ICON-3-HOVER.png';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stats: {
        totalCustomers: 0,
        totalRequests: 0,
        totalInspections: 0,
      },
      loading: true,
      error: '',
      hoverUsers: false,
      hoverRequests: false,
      hoverInspections: false,
    };
  }

  componentDidMount() {
    document.title = "Prep for Sale- Dashboard";
    if(localStorage.getItem("DCuserid")==null) {
      this.setState({
        logredirect: true,
        pagename:'/'
      });
    }
    this.fetchTotalCustomers();
    this.fetchTotalRequests();
    this.fetchTotalInspections();
  }

  handleUsersHover = (hover) => {
    this.setState({ hoverUsers: hover });
  };

  handleRequestsHover = (hover) => {
    this.setState({ hoverRequests: hover });
  };

  handleInspectionsHover = (hover) => {
    this.setState({ hoverInspections: hover });
  };

  fetchTotalCustomers = () => {
 axiosInstance.get(
  Serverurl + 'customer/customergetcount'
)
      .then(res => {
        this.setState(prevState => ({
          stats: {
            ...prevState.stats,
            totalCustomers: res.data.totalCustomers
          },
          loading: false
        }));
      })
      .catch(err => {
        console.error('Error fetching customers:', err);
        this.setState({ error: 'Failed to fetch customers', loading: false });
      });
  };

  fetchTotalRequests = () => {
    axiosInstance.get(Serverurl+'requestaquote/requestgetcount')
      .then(res => {
        this.setState(prevState => ({
          stats: {
            ...prevState.stats,
            totalRequests: res.data.totalRequests
          },
          loading: false
        }));
      })
      .catch(err => {
        console.error('Error fetching requests:', err);
        this.setState({ error: 'Failed to fetch requests', loading: false });
      });
  };

  fetchTotalInspections = () => {
    axiosInstance.get(Serverurl+'inspectionbooking/inspectiongetcount')
      .then(res => {
        this.setState(prevState => ({
          stats: {
            ...prevState.stats,
            totalInspections: res.data.totalInspections
          },
          loading: false
        }));
      })
      .catch(err => {
        console.error('Error fetching inspections:', err);
        this.setState({ error: 'Failed to fetch inspections', loading: false });
      });
  };

  render() {
    if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 

    if (this.state.loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
          <CircularProgress />
        </Box>
      );
    }

    if (this.state.error) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
          <Alert severity="error">{this.state.error}</Alert>
        </Box>
      );
    }

    return (
	 <div className="maincontentDiv">
      <Box sx={{ pb: 26, paddingTop: 5 }}>
        <Typography className="contentHeading" variant="h4" gutterBottom align="center">
          Dashboard
        </Typography>
        <Grid container spacing={8} sx={{marginTop:5, justifyContent: 'center' }}>
          
          <Grid item xs={12} sm={4}>
            <Paper 
              sx={{ 
                padding: 3, 
                textAlign: 'center',
                transition: 'transform 0.2s, box-shadow 0.2s',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 3
                }
              }}
              onMouseEnter={() => this.handleUsersHover(true)}
              onMouseLeave={() => this.handleUsersHover(false)}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                <img
                  src={this.state.hoverUsers ? usersHoverIcon : usersIcon}
                  alt="Users"
                  style={{ 
                    
                    marginRight: '16px',
                    transition: 'opacity 0.2s'
                  }}
                />
                <Box>
                  <Typography variant="h2" sx={{ fontWeight: 'bold', m: 0 }}>
                    {this.state.stats.totalCustomers}
                  </Typography>
                  <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                    Total Users
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper 
              sx={{ 
                padding: 3, 
                textAlign: 'center',
                transition: 'transform 0.2s, box-shadow 0.2s',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 3
                }
              }}
              onMouseEnter={() => this.handleRequestsHover(true)}
              onMouseLeave={() => this.handleRequestsHover(false)}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                <img
                  src={this.state.hoverRequests ? requestsHoverIcon : requestsIcon}
                  alt="Requests"
                  style={{ 
                    
                    marginRight: '16px',
                    transition: 'opacity 0.2s'
                  }}
                />
                <Box>
                  <Typography variant="h2" sx={{ fontWeight: 'bold', m: 0 }}>
                    {this.state.stats.totalRequests}
                  </Typography>
                  <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                    Requests
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper 
              sx={{ 
                padding: 3, 
                textAlign: 'center',
                transition: 'transform 0.2s, box-shadow 0.2s',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 3
                }
              }}
              onMouseEnter={() => this.handleInspectionsHover(true)}
              onMouseLeave={() => this.handleInspectionsHover(false)}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                <img
                  src={this.state.hoverInspections ? inspectionsHoverIcon : inspectionsIcon}
                  alt="Inspections"
                  style={{ 
                    
                    marginRight: '16px',
                    transition: 'opacity 0.2s'
                  }}
                />
                <Box>
                  <Typography variant="h2" sx={{ fontWeight: 'bold', m: 0 }}>
                    {this.state.stats.totalInspections}
                  </Typography>
                  <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                    Inspections
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>

        </Grid>
      </Box></div>
    );
  }
}

export default Dashboard;
